import { useSelector } from 'react-redux';
import { Add as AddIcon } from '@mui/icons-material';

export default function AddFAB({ handleAddClick }) {
  const { navBar } = useSelector((state) => state.systemBar);

  return (
    <button
      type="button"
      className="fixed right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#135bec] text-white shadow-lg transition-transform active:scale-95"
      style={{ bottom: `${navBar + 20}px` }}
      onClick={() => handleAddClick?.()}
    >
      <AddIcon className="!text-3xl" />
    </button>
  );
}
